var render = function render(){
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "py-5 gap-x-4 gap-y-10 items-center place-content-center",
    class: (_class = {
      'hover:bg-indigo-200': !_vm.disabled,
      'cursor-not-allowed': _vm.disabled,
      'bg-indigo-200 border-l-2 border-indigo-600': _vm.isAccordionDisplayed
    }, _class[`grid ${_vm.grid}`] = true, _class.heightLine = true, _class),
    on: {
      "click": function ($event) {
        return _vm.$emit('clickOnItem');
      }
    }
  }, [_vm._t("description")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-300",
      "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isAccordionDisplayed,
      expression: "isAccordionDisplayed"
    }],
    staticClass: "bg-white px-10 py-5"
  }, [_vm._t("content")], 2)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }